// extracted by mini-css-extract-plugin
export default {"bottomSheet":"BottomSheet_bottomSheet__JS8aS","slideUp":"BottomSheet_slideUp__nxP0m","header":"BottomSheet_header__3LU3r","handler":"BottomSheet_handler__qdfXR"};